import * as React from 'react';
import {line as d3line} from 'd3-shape';
import {Scales} from '../../types';

interface LineProps {
  scales: Scales;
  at: number;
  orientation: 'vertical' | 'horizontal';
  stroke: string;
}

/**
 * Draw a vertical or horizontal line,
 *
 * at - either scaled x or y depending on the orientation.
 */
export class Line extends React.Component<LineProps> {
  render() {
    const {scales, at, stroke, orientation} = this.props;
    const {xScale, yScale} = scales;

    const line = d3line()
      .x(d => xScale(d[0])!)
      .y(d => yScale(d[1])!);

    const data: [number, number][] = [
      orientation === 'vertical' ? [at, 0.3] : [0.2, at],
      orientation === 'vertical' ? [at, 99.7] : [99.8, at],
    ];

    return (
      <g>
        <path
          d={line(data)!}
          style={{
            stroke: stroke,
            strokeWidth: 0.5,
            strokeLinecap: 'round',
            fill: 'none',
          }}
        />
      </g>
    );
  }
}
